import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Service Worker for PWA support - Temporarily disabled for debugging
// Uncomment to re-enable when issues are resolved
/*
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then((registration) => {
        console.log('drbooking SW registered:', registration.scope);
      })
      .catch((error) => {
        console.log('drbooking SW registration failed:', error);
      });
  });
}
*/

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
